<template>
  <div class="store-performance">
    <!-- 客户服务绩效 -->
    <div class="performance-cell">
      <div class="cell-title">客户服务绩效</div>
      <div class="cell-content">
        <div class="details details1">
          <div class="delivery-mode">
            <div class="own">卖家自配送</div>
            <div class="amazon">亚马逊配送</div>
          </div>
          <div class="order-defect">
            <div class="order-col rate">
              <span>订单缺陷率</span>
              <span class="w124" :class="{abnormal: !pageDetails.serves.orderDefects.orderWithDefects.completeTarget}">{{ pageDetails.serves.orderDefects.orderWithDefects.rate }}</span>
            </div>
            <div class="order-col jcfe">
              <span class="w110">暂未开放</span>
              <span class="w124">{{ pageDetails.serves.orderDefects.orderWithDefects.count }}个订单（共{{ pageDetails.serves.orderDefects.count }}个）</span>
            </div>
            <div class="order-col">
              <span>目标：低于1%</span>
              <span class="w124">{{ pageDetails.serves.orderDefects.duration }}天</span>
            </div>
          </div>
          <div class="index-title">订单缺陷率包含三个不同的指标</div>
          <div class="index-cell">
            <span>负面反馈</span>
            <div class="df">
              <span class="w110">暂未开放</span>
              <span class="w144">{{ pageDetails.serves.orderDefects.negativeFeedBacks.rate }}</span>
            </div>
          </div>
          <div class="index-cell">
            <span>亚马逊商城交易保障索赔</span>
            <div class="df">
              <span class="w110">暂未开放</span>
              <span class="w144">{{ pageDetails.serves.orderDefects.azclaims.rate }}</span>
            </div>
          </div>
          <div class="index-cell">
            <span>信用卡拒付索赔</span>
            <div class="df">
              <span class="w110">暂未开放</span>
              <span class="w144">{{ pageDetails.serves.orderDefects.chargeBacks.rate }}</span>
            </div>
          </div>
        </div>
        <div class="view-details" @click="anchorRoll('#customer-service')">
          查看详情 <i class="el-icon-arrow-right"></i>
          <div></div>
        </div>
      </div>
    </div>
    <!-- 商品政策合规性 -->
    <div class="performance-cell">
      <div class="cell-title">商品政策合规性</div>
      <div class="cell-content">
        <div class="details details2">
          <div class="details-col">
            <span>目标：没有收到投诉或出现反政策的行为</span>
            <span>配送方：卖家和亚马逊</span>
          </div>
          <div class="details-col" v-for="(item, index) in productCompliance" :key="index">
            <span>{{ item.type }}</span>
            <span :class="{abnormal: !item.completeTarget}">{{ item.num }}</span>
          </div>
        </div>
        <div class="view-details" @click="anchorRoll('#product-compliance')">
          查看详情 <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <!-- 配送绩效 -->
    <div class="performance-cell">
      <div class="cell-title">配送绩效</div>
      <div class="cell-content">
        <div class="details details3">
          <div class="details-title">
            <div class="col-right">卖家自配送</div>
          </div>
          <div class="details-col" v-for="(item, index) in distributionPerformance" :key="index">
            <div class="cell header">
              <span>{{ item.type }}</span>
              <span class="col-right">{{ item.rate }}</span>
            </div>
            <div class="cell">
              <span>{{ item.target }}</span>
              <span class="col-right">{{ item.count }}个订单（共{{ item.totalCount }}个）</span>
            </div>
          </div>
        </div>
        <div class="view-details" @click="anchorRoll('#distribution-performance')">
          查看详情 <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageDetails: {
      default: () => ({
        commodityPolicies: {},
        distributions: {},
        serves: {}
      })
    }
  },
  data() {
    return {}
  },
  methods: {
    anchorRoll(id) {
      this.$emit("anchorRoll", id)
    },
  },
  computed: {
    productCompliance () {
      let productCompliance = [
        {type: "知识产权投诉", num: "0", completeTarget: true},
        {type: "商品安全投诉", num: "0", completeTarget: true},
        {type: "商品真实性投诉", num: "0", completeTarget: true},
        {type: "上架政策违规", num: "0", completeTarget: true},
        {type: "商品状况买家投诉", num: "暂未开放", completeTarget: true},
        {type: "违反受限商品政策", num: "暂未开放", completeTarget: true},
        {type: "违反买家商品评论政策", num: "暂未开放", completeTarget: true}
      ]
      if (this.pageDetails.commodityPolicies.intellectualPropertyData) {
        let {defectCount, completeTarget} = this.pageDetails.commodityPolicies.intellectualPropertyData
        productCompliance[0].num = defectCount
        productCompliance[0].completeTarget = completeTarget
      }
      if (this.pageDetails.commodityPolicies.productSafetyData) {
        let { defectCount, completeTarget } = this.pageDetails.commodityPolicies.productSafetyData
        productCompliance[1].num = defectCount
        productCompliance[1].completeTarget = completeTarget
      }
      if (this.pageDetails.commodityPolicies.productAuthenticityData) {
        let { defectCount, completeTarget } = this.pageDetails.commodityPolicies.productAuthenticityData
        productCompliance[2].num = defectCount
        productCompliance[2].completeTarget = completeTarget
      }
      if (this.pageDetails.commodityPolicies.listingPolicyData) {
        let { defectCount, completeTarget } = this.pageDetails.commodityPolicies.listingPolicyData
        productCompliance[3].num = defectCount
        productCompliance[3].completeTarget = completeTarget
      }
      return productCompliance
    },
    distributionPerformance() {
      let distributionPerformance = [
        {type: "迟发率", rate: "0", target: "目标：低于4%", count: 0, totalCount: 0, completeTarget: true},
        {type: "配送前取消率", rate: "0", target: "目标：低于2.5%", count: 0, totalCount: 0, completeTarget: true},
        {type: "有效追踪率", rate: "0", target: "目标：超过95%", count: 0, totalCount: 0, completeTarget: true},
      ]
      if (this.pageDetails.distributions.lateShipment && this.pageDetails.distributions.lateShipment[1]) {
        let {rate, count, totalCount, completeTarget} = this.pageDetails.distributions.lateShipment[1]
        distributionPerformance[0].rate = rate
        distributionPerformance[0].count = count
        distributionPerformance[0].totalCount = totalCount
        distributionPerformance[0].completeTarget = completeTarget
      }
      if (this.pageDetails.distributions.preFulfillmentCancellation) {
        let {rate, count, totalCount, completeTarget} = this.pageDetails.distributions.preFulfillmentCancellation
        distributionPerformance[1].rate = rate
        distributionPerformance[1].count = count
        distributionPerformance[1].totalCount = totalCount
        distributionPerformance[1].completeTarget = completeTarget
      }
      if (this.pageDetails.distributions.validTracking) {
        let {rate, count, totalCount, completeTarget} = this.pageDetails.distributions.validTracking
        distributionPerformance[2].rate = rate
        distributionPerformance[2].count = count
        distributionPerformance[2].totalCount = totalCount
        distributionPerformance[2].completeTarget = completeTarget
      }
      return distributionPerformance
    }
  }
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.df {
  display: flex;
}
.store-performance {
  display: flex;
  justify-content: space-between;
  padding: 0 0 15px 0;
  .performance-cell {
    width: 32.5%;
    border-radius: 2px;
    border: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // &:hover {
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    // }
    .cell-title {
      height: 50px;
      line-height: 50px;
      padding-left: 19px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      border-bottom: 1px solid #eee;
    }
    .cell-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .details {
        flex: 1;
        &.details1 {
          .delivery-mode {
            padding: 16px 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 12px;
            color: #333;
            .own {
              width: 120px;
            }
            .amazon {
              width: 144px;
            }
          }
          .order-defect {
            margin: 0 10px;
            padding: 10px;
            border: 1px solid #dcdfe6;
            border-radius: 2px;
            .order-col {
              line-height: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 12px;
              color: #666;
              &.rate {
                font-size: 14px;
                color: #666;
                font-weight: 600;
              }
              &.jcfe {
                justify-content: flex-end;
                padding: 10px 0;
              }
              .w124 {
                width: 124px;
              }
              .w110 {
                width: 110px;
              }
            }
          }
          .index-title {
            line-height: 1;
            padding: 20px 0 10px 19px;
            font-weight: 600;
            font-size: 12px;
            color: #666;
          }
          .index-cell {
            padding: 0 0 40px 19px;
            font-size: 12px;
            color: #666;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .w144 {
              width: 144px;
            }
            .w110 {
              width: 110px;
            }
          }
        }
        &.details2 {
          padding: 16px 20px 0;
          .details-col {
            line-height: 1;
            padding-bottom: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            color: #333;
          }
        }
        &.details3 {
          .col-right {
            width: 150px;
          }
          .details-title {
            line-height: 1;
            padding: 16px 20px 10px 0;
            font-size: 12px;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          .details-col {
            padding: 0 20px 60px 20px;
            font-size: 14px;
            color: #666;
            .cell {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .header {
              font-weight: bold;
              padding-bottom: 12px;
            }
          }
        }
      }
      .view-details {
        padding: 0 10px 10px 0;
        font-size: 12px;
        color: #1F6EEF;
        text-align: right;
        cursor: pointer;
      }
    }
  }
}
</style>